module.exports = __webpack_public_path__ + "assets/0ab2899303fe9af63faf6da0b3dcf936.mp3";